import {
  type DefaultAppRouteSetting,
  resolveDefaultAppRoute,
} from "shared/helpers/default-app-route/defaultAppRouteSetting";
import { getDeviceInfo } from "hub/src/utils/getDeviceInfo";

/**
 * The landing route for this device from the society's `default_app_route`
 * setting, or `undefined` when the society has none - callers keep their own
 * fallback for that case. Reads the device once: where a member lands is
 * decided at that moment, so a later resize or rotation never redirects them.
 */
type GetDefaultAppRouteProps = {
  /** The society's `default_app_route` setting from the session. */
  setting?: DefaultAppRouteSetting;
};

export const getDefaultAppRoute = ({
  setting,
}: GetDefaultAppRouteProps): string | undefined =>
  setting
    ? resolveDefaultAppRoute({ setting, device: getDeviceInfo() })
    : undefined;
